export default [
  {
    id: 'nywgf',
    authRequired: true,
    name: 'New York Wine and Grape Foundation',
    description: 'Includes the VineBalance Worksheet.',
    logo: {
      url: 'https://newyorkwines.org/wp-content/uploads/2020/04/NYW-RGB-wt-type-Hor-400x126.png',
      alt: 'NY Wines Logo'
    },
    url: 'https://nywgf.efficientvineyard.com'
  }
]
